import { useMemo } from 'react'

import { getFilteredConversationSections } from 'conversations/modules/user/sections/selectors'
import { useSelector } from 'react-redux'
import { ConversationSidebarSectionConfig } from 'shared/typings/conversationsSidebar/Filters'

export const useSections = () => useSelector(getFilteredConversationSections)

export const useSectionConfig = (
  sectionID: string | undefined
): ConversationSidebarSectionConfig | undefined => {
  const customSidebarSections = useSections()
  return useMemo(() => {
    if (!sectionID) {
      return undefined
    }
    return customSidebarSections.find((section) => section.id === sectionID)
  }, [customSidebarSections, sectionID])
}

export const useSectionConfigProperty = (
  sectionID: string | undefined,
  property: keyof ConversationSidebarSectionConfig
): any | undefined => {
  const customSidebarSections = useSections()
  return useMemo(() => {
    if (!sectionID) {
      return undefined
    }
    return customSidebarSections.find((section) => section.id === sectionID)?.[property]
  }, [customSidebarSections, sectionID, property])
}

export const useSectionConfigByType = (
  sectionType: 'all-convos' | 'no-participants' | 'my-convos'
): ConversationSidebarSectionConfig | undefined => {
  const customSidebarSections = useSections()
  return useMemo(
    () => customSidebarSections.find((section) => section.type === sectionType),
    [customSidebarSections, sectionType]
  )
}
